import * as React from "react"

// #region Navigation List

import { cva } from "./cva.ts"

// #region Navigation List

export const NavList = React.forwardRef<HTMLElement, NavListProps>(
  ({ children, className, ...props }, ref) => (
    <nav className={classForNavList({ className })} ref={ref} {...props}>
      <ul className="contents">
        {[children].flat().map((child, index) => (
          <li className="contents" key={index}>
            {React.cloneElement(child, {
              ...child.props,
              className: classForNavItem({
                current: child.props.hasOwnProperty("aria-current"),
                className: child.props?.className,
              }),
            })}
          </li>
        ))}
      </ul>
    </nav>
  ),
)

export type NavListProps = Omit<React.ComponentProps<"nav">, "children"> & {
  children:
    | React.ReactElement<{ className?: string }>
    | Array<React.ReactElement<{ className?: string }>>
}

export const classForNavList = cva([
  "flex flex-row gap-8",
  "[box-shadow:var(--gray-6)_0_-1px_0_0_inset]",
])

// #endregion

// #region Navigation Item

export const classForNavItem = cva(["block pb-3 text-sm bshadow-b"], {
  variants: {
    current: {
      true: ["text-gray-12 [--tw-border-color:var(--gray-12)]"],
      false: [
        "text-gray-11 [--tw-border-color:var(--gray-6)]",
        "hover:text-gray-12 focus-visible:text-gray-12",
      ],
    },
  },
})

// #endregion
